import { ENDPOINTS } from '@/settings/endpoints';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache, NormalizedCacheObject } from 'apollo-cache-inmemory';
import { createHttpLink } from 'apollo-link-http';
import { RetryLink } from 'apollo-link-retry';
import { ApolloLink } from 'apollo-link';
import { DocumentNode } from 'graphql';

const getStellateApolloClient = (
  customHeaders: { [key: string]: any } | undefined,
): ApolloClient<NormalizedCacheObject> => {
  const STELLATE_TOKEN = process.env.VUE_APP_GRAPH_CDN_TOKEN;
  const authorization = `Bearer ${STELLATE_TOKEN}`;
  const links = [];

  const stellateHttpLink = createHttpLink({
    uri: ENDPOINTS.stellate,
    headers: {
      authorization,
      ...customHeaders,
    },
    fetch,
  });

  links.push(new RetryLink());
  links.push(stellateHttpLink);

  const stellateLink = ApolloLink.from(links);

  return new ApolloClient({
    link: stellateLink,
    cache: new InMemoryCache(),
    connectToDevTools: true,
    defaultOptions: {
      query: {
        fetchPolicy: 'no-cache',
      },
    },
  });
};

export const stellateQuery = async (
  query: DocumentNode,
  variables?: { [key: string]: any },
  customHeaders?: { [key: string]: any },
): Promise<any> => {
  const apolloClient = getStellateApolloClient(customHeaders);

  return apolloClient.query<any>({
    query,
    variables,
  });
};

export const stellateMutation = async (
  mutation: DocumentNode,
  variables?: { [key: string]: any },
  customHeaders?: { [key: string]: any },
): Promise<any> => {
  const apolloClient = getStellateApolloClient(customHeaders);

  return apolloClient.mutate<any>({
    mutation,
    variables,
  });
};
